import React from 'react';
import PropTypes from 'prop-types';

const SearchInput = (props) => {
  const {
    filterList,
    placeholder,
  } = props;
  return (
    <React.Fragment>
      <input
        type="text"
        placeholder={placeholder}
        onChange={filterList}
      />
      {props.children}
    </React.Fragment>
  );
};

SearchInput.defaultProps = {
  children: null,
};

SearchInput.propTypes = {
  children: PropTypes.node,
  filterList: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/components/SearchInput.jsx